import { createContext, useContext } from "react";

/**
 * True while the session-expired dialog is open (SessionGate). Anything that opens a dialog by itself (What's new) waits
 * while it is true, so the two never stack.
 */
export const SessionExpiredContext = createContext(false);

export function useSessionExpired(): boolean {
  return useContext(SessionExpiredContext);
}
